import { createTheme, Theme, ThemeOptions } from '@mui/material'
import { deDE, enUS } from '@mui/material/locale'
import FsMeWebBold from 'url:../shared/assets/fonts/FSMeWeb-Bold.woff'
import FsMeWebRegular from 'url:../shared/assets/fonts/FSMeWeb-Regular.woff'

const getAppTheme = (language: string) => {
  const defaultTheme: ThemeOptions | undefined = {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1300,
        xl: 1536,
      },
    },
    typography: {
      fontFamily: [
        'FSMeWeb',
        'Roboto Condensed',
        'Roboto',
        '"Helvetica"',
        'Arial',
        'sans-serif',
      ].join(','),
      subtitle1: {
        fontFamily: 'FSMeWeb',
        textTransform: 'none',
        fontWeight: '400',
        fontSize: 14,
      },
    },
    palette: {
      primary: {
        main: '#8e0038',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#646464',
      },
      info: {
        main: '#646464',
      },
      text: {
        secondary: '#807e6f'
      },
      background: {
        default: '#f7dcbb',
        paper: '#ffffff',
      },
    },
    components: {
      MuiTypography: {
        styleOverrides: {
          body1: {
            fontFamily: 'FSMeWeb',
          },
          body2: {
            fontFamily: 'FSMeWeb',
            fontSize: '14px',
          },
          h2: {
            fontFamily: 'FSMeWeb',
            fontWeight: 700,
            fontSize: '1.5em',
          },
          h3: {
            fontFamily: 'FSMeWeb',
            fontSize: '18px',
          },
          h4: {
            fontFamily: 'FSMeWeb',
            fontSize: '1em',
            fontWeight: 700,
          },
          h5: {
            fontFamily: 'FSMeWeb',
            fontSize: '14px',
            fontWeight: 700,
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: `
        @font-face {
          font-family: 'FSMeWeb';
          font-style: normal;
          font-weight: 600;
          src: local('FSMeWeb'), local('FSMeWeb-Bold'), url(${FsMeWebBold}) format('woff');
        }
        @font-face {
          font-family: 'FSMeWeb';
          font-style: normal;
          font-weight: 400;
          src: local('FSMeWeb'), local('FSMeWeb-Regular'), url(${FsMeWebRegular}) format('woff');
        }
      `
      },
      MuiTabs: {
        styleOverrides: {
          root: ({ theme })=> ({
            backgroundColor: '#ffffff !important',
            borderTop: '1px solid #8e0038',

            'a': {
              color: `${theme.palette.text.secondary} !important`,
              textTransform: 'capitalize',
              '&.Mui-selected': {
                fontWeight: 400
              }
            },
            '.MuiTabs-indicator': {
              backgroundColor: '#8e0038 !important'
            }
          })
        }
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            border: '1px solid #b5b5b5',
            background: 'transparent',
            width: '100%',
            height: 'fit-content',
            boxShadow: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            color: '#646464',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: '#707070',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginTop: 0,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          textPrimary: {
            color: '#8e0038',
            '&:hover': {
              color: '#807e6f',
            },
            textTransform: 'initial',
          },
          textSecondary: {
            color: '#807e6f',
            '&:hover': {
              color: '#8e0038',
            },
            textTransform: 'initial',
          },
          containedPrimary: {
            color: '#FFFFFF',
            backgroundColor: '#8e0038',
            border: '1px solid #8e0038',
            '&:hover': {
              color: '#FFFFFF',
              backgroundColor: '#807e6f',
              border: '1px solid #807e6f',
            },
            textTransform: 'initial',
          },
          containedSecondary: {
            color: '#FFFFFF',
            backgroundColor: '#807e6f',
            border: '1px solid #807e6f',
            '&:hover': {
              color: '#FFFFFF',
              backgroundColor: '#8e0038',
              border: '1px solid #8e0038',
            },
            textTransform: 'initial',
          },
        },
      },
    },
  }
  const theme: Theme = createTheme(defaultTheme, language === 'de' ? deDE : enUS)
  return theme
}
export default getAppTheme
